import _ from 'lodash';
import React from 'react';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';

import './SlideItem.scss';
import colorHelper from '../../lib/colorLuminance';
import { slideTitleFormatter } from '../../lib/titleFormatter';
import ItemTypes from '../ItemTypes/ItemTypes';
import Slide from '../Slide/Slide';
import SlidePlaceholder from '../Slide/SlidePlaceholder'

class SlideItem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            deletePrompted: false
        }
    }

    deleteSlide(e, id) {
        if (this.state.deletePrompted) {
            this.props.removeSlide(e, id);
        } else {
            this.setState({deletePrompted: true});
        }
    }

    render() {
        const { currentSlideId,
                item, 
                connectDragSource, 
                connectDropTarget, 
                isDragging, 
                editSlide, 
                slidesData,
                currency,
                companyProfile } = this.props;

        const holderStyle = item.backgroundImage ? {
            background: `${colorHelper.colorLuminance('#002f65', '0.7')} \
url('${item.backgroundImage}') no-repeat center center`,
        } : { background: `${colorHelper.colorLuminance('#002f65', '0.7')}` };

        const slideClasses = ['slide', 'each-slide', 'thumbnail-slide'];
        if (currentSlideId === item.id) {
            slideClasses.push('active');
        }

        return connectDragSource(connectDropTarget(
            <div className={slideClasses.join(' ')} onMouseLeave={ () => this.setState({deletePrompted: false}) }>
                <SlidePlaceholder
                    companyProfile={companyProfile}
                />
                {!isDragging && <div className="inner-holder" style={holderStyle}>
                    <Slide
                        key={item.id}
                        ref={item.id}
                        slide={item}
                        slidesData={slidesData}
                        slideId={item.id}
                        active={true}
                        isThumbnail={true}
                        companyProfile={companyProfile}
                        currency={currency}
                        //isPlaying={this.state.slideShowInterval !== null}
                        //isEditingWidget={this.state.isEditingWidget}
                        //startEditing={SalesTv.startEditing}
                    />
                    <div className='slide-settings'>
                        <button onClick={(e) => this.deleteSlide(e, item.id)} style={this.state.deletePrompted ? {background: '#940000'} : {}}>
                            <i className='fa fa-trash' aria-hidden='true'></i>
                        </button>
                        <button onClick={() => editSlide(item)}>
                            <i className='fa fa-cog' aria-hidden='true'></i>
                        </button>
                    </div>
                </div>}
            </div>,
        ));
    }
}

const spec = {
    beginDrag: props => (
        { id: props.item.id, index: props.index, tvIndex: props.item.tvIndex || 0 }
    ),
    isDragging: (props, monitor) => monitor.getItem().id === props.item.id,
    endDrag(props, monitor) {
        if (!monitor.didDrop()) {
            return;
        }

        props.reorderDone();
    },
};

const dropSpec = {
    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const dragTvId = monitor.getItem().tvIndex;
        const hoverIndex = props.index;
        const hoverTvId = props.tvIndex;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex && dragTvId === hoverTvId) {
            return;
        }

        // Determine rectangle on screen
        const hoverBoundingRect =
            findDOMNode(component).getBoundingClientRect(); // eslint-disable-line

        // Get horizontal middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // Determine mouse position
        const clientOffset = monitor.getClientOffset();

        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%

        // Dragging down
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        // Dragging up
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }

        if (dragTvId !== hoverTvId) {
            // Time to actually perform the action
            props.moveToTv(monitor.getItem().id, hoverTvId, hoverIndex);
        } else {
            props.reorder(dragIndex, hoverIndex, props.item);
        }

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        monitor.getItem().index = hoverIndex; // eslint-disable-line no-param-reassign
        monitor.getItem().tvIndex = hoverTvId; // eslint-disable-line no-param-reassign
    },
};

const collect = (connect, monitor) => ({
    // Call this function inside render()
    // to let React DnD handle the drag events:
    connectDragSource: connect.dragSource(),
    // You can ask the monitor about the current drag state:
    isDragging: monitor.isDragging(),
});

/**
 * Specifies which props to inject into your component.
 */
const dropCollect = (connect, monitor) => ({
    // Call this function inside render()
    // to let React DnD handle the drag events:
    connectDropTarget: connect.dropTarget(),
    // You can ask the monitor about the current drag state:
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true }),
    canDrop: monitor.canDrop(),
    itemType: monitor.getItemType(),
});

SlideItem.propTypes = {
    index: React.PropTypes.number, // eslint-disable-line react/no-unused-prop-types
    item: React.PropTypes.object,
    sharedProps: React.PropTypes.object, // eslint-disable-line react/no-unused-prop-types
    connectDragSource: React.PropTypes.func,
    connectDropTarget: React.PropTypes.func,
    isDragging: React.PropTypes.bool,
    moveToTv: React.PropTypes.func, // eslint-disable-line react/no-unused-prop-types
    editSlide: React.PropTypes.func,
};

export default _.flow(
    DragSource(ItemTypes.SLIDE, spec, collect),
    DropTarget(ItemTypes.SLIDE, dropSpec, dropCollect),
)((SlideItem));



/** WEBPACK FOOTER **
 ** ./client/components/SlideItem/SlideItem.jsx
 **/